/**
 * The phone Sort sheet's rules. Picking a column sorts it in its first
 * direction (numbers high→low, the label column A→Z — the desktop header's
 * first click); picking it again reverses. "Default" clears the sort.
 */
import { ViewSort } from "../../../types/reportsV2";
import { LABEL_SORT_KEY } from "../v2/model/viewConfig";
import { firstSortDir } from "../v2/ReportTreeTable";

export function toggleSheetSort(
  current: ViewSort | null,
  key: string,
): ViewSort {
  if (current?.key === key) {
    return { key, dir: current.dir === "asc" ? "desc" : "asc" };
  }
  return { key, dir: firstSortDir(key) };
}

/** Second line of the selected sort option. */
export function sortDirectionLabel(sort: ViewSort): string {
  if (sort.key === LABEL_SORT_KEY) {
    return sort.dir === "asc"
      ? "Oldest dates first, A–Z · tap to reverse"
      : "Newest dates first, Z–A · tap to reverse";
  }
  return sort.dir === "desc"
    ? "Highest first · tap to reverse"
    : "Lowest first · tap to reverse";
}
